import React from "react";
import LogosItem from "./logos.item.v1";

type LogosGridProps = {
    items: Array< { item: TLogoItem; } | TLogoItem >
}

export default class LogosGrid extends React.Component<LogosGridProps> {
    
    renderLogoItem = (x: { item: TLogoItem } | TLogoItem, index: number) => {
        const logoItem: TLogoItem = (x as unknown as any).item || x;
        return <LogosItem key={'logo-'+index} href={logoItem.href} src={logoItem.image?.imageFile} name={logoItem.name} />
    }
    
    render(): React.ReactNode {
        return <>
        <div className="w-full grid grid-cols-2 gap-0.5 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            {this.props.items.map(this.renderLogoItem)}
        </div>
        </>;
    }
}